import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SignatureSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SignatureSVG;
